import React from "react";
import cx from "classnames";

export const ArrowLeft = ({
	onClick,
	className,
}: {
	onClick: (e: any) => void;
	className?: string;
}) => {
	return (
		<button
			aria-label="Previous slide"
			onClick={onClick}
			className={cx("arrow arrow--left", className)}
		>
			<svg
				width="18"
				height="11"
				viewBox="0 0 18 11"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7.65749 9.97542L1.43249 6.23541C0.577488 5.72142 0.576488 4.48242 1.43149 3.96642L7.69049 0.192415C8.57549 -0.340585 9.70349 0.298415 9.69849 1.33142L9.69049 2.94941H16.6765C17.4075 2.94941 18.0005 3.54142 18.0005 4.27342V5.89341C18.0005 6.62341 17.4075 7.21741 16.6765 7.21741H9.67149L9.66449 8.84642C9.65949 9.87242 8.53849 10.5034 7.65749 9.97542Z"
					fill="black"
				/>
			</svg>
		</button>
	);
};

export const ArrowRight = ({
	onClick,
	className,
}: {
	onClick: (e: any) => void;
	className?: string;
}) => {
	return (
		<button
			aria-label="Next slide"
			onClick={onClick}
			className={cx("arrow arrow--right", className)}
		>
			<svg
				width="18"
				height="11"
				viewBox="0 0 18 11"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10.3425 9.97542L16.5675 6.23541C17.4225 5.72142 17.4235 4.48242 16.5685 3.96642L10.3095 0.192415C9.42451 -0.340585 8.29651 0.298415 8.30151 1.33142L8.30951 2.94941H1.32351C0.592512 2.94941 -0.000488281 3.54142 -0.000488281 4.27342V5.89341C-0.000488281 6.62341 0.592512 7.21741 1.32351 7.21741H8.32851L8.33551 8.84642C8.34051 9.87242 9.46151 10.5034 10.3425 9.97542Z"
					fill="black"
				/>
			</svg>
		</button>
	);
};

export const Dots = ({
	slider,
	currentSlide,
	className,
}: {
	slider: any;
	currentSlide: number;
	className?: string;
}) => {
	return (
		<div className={cx("dots", className)}>
			{[...Array(slider.details().size).keys()].map((idx) => {
				return (
					<button
						aria-label={`Go to slide number ${idx}`}
						key={idx}
						onClick={() => {
							slider.moveToSlideRelative(idx);
						}}
						className={"dot" + (currentSlide === idx ? " active" : "")}
					/>
				);
			})}
		</div>
	);
};
